import React from "react";
import "./MobileServices.css";
import { useNavigate } from "react-router-dom";
import { MdPhoneAndroid } from "react-icons/md";

import mobileBasicImg from "../assets/mobser.png";

const services = [
  {
    name: "Mobile To Customer Detail",
    img: mobileBasicImg,
    path: "/dashboard/mobile-basic"
  }
];

export default function MobileServices() {

  const navigate = useNavigate();

  return (
    <div className="mobile-services-wrapper">

      <h2 className="mobile-title">
        <MdPhoneAndroid className="mobile-icon" />
        All Mobile Related Services
      </h2>

      <div className="mobile-divider"></div>

      <div className="mobile-services-box">
        {services.map((item, i) => (
          <div className="mobile-service-card" key={i}>

            <div
              className="mobile-circle-box"
              onClick={() => navigate(item.path)}
            >
              <img src={item.img} alt={item.name} draggable="false" />
            </div>

            <p className="mobile-service-name">
              {item.name}
            </p>

          </div>
        ))}
      </div>

    </div>
  );
}
